import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { currentTheme } from '../../../global.variable';
import { AppService } from '../../app.service';
import { DataCheckService } from '../../shared/services/data-check.service';

@Component({
  selector: 'gtapp-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  currentTheme: string = currentTheme;
  isSuperUser: any;
  isPrimeContractorUser: boolean =
    this.dataCheckService.isPrimeContractorUser();
  constructor(
    private appService: AppService,
    private router: Router,
    private dataCheckService: DataCheckService,
  ) {}

  ngOnInit(): void {
    this.isSuperUser = this.dataCheckService.isSuperUser();
  }
  goToHome() {
    let userData = this.appService.getUserData();
    this.isSuperUser = this.dataCheckService.isSuperUser();
    if (userData && userData.access) {
      if (this.isSuperUser === true) {
        this.router.navigate(['gtadmin/dashboard']);
      } else if (this.isPrimeContractorUser) {
        this.router.navigate(['pc']);
      } else {
        this.router.navigate(['/']);
      }
    } else {
      this.router.navigate(['/login']);
    }
  }
}
